/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const address = {
  addressForm: {
    title: 'Título',
    defaultTitle: 'Título',
    titleOptional: 'Título (opcional)',
    firstName: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    lastName: {
      label: 'Sobrenome',
      placeholder: 'Sobrenome',
    },
    address1: 'Endereço 1',
    address2: 'Endereço 2 (opcional)',
    country: 'País/Región',
    city: {
      label: 'Cidade',
      placeholder: 'Cidade',
    },
    state: 'Estado',
    zipCode: {
      label: 'Código Postal',
      placeholder: 'Postal Code/Zip',
    },
    phoneNumber: {
      label: 'Número de telefone (opcional)',
      placeholder: '(555) 555 - 0123',
    },
    cellphone: {
      label: 'Número de telemóvel (opcional)',
      placeholder: '(555) 555 - 0123',
    },
    saveAsDefault: 'Salvar como padrão',
    chooseAddress: 'Escolha o endereço',
    streetAddress: 'Endereço',
    aptSuite: 'Apto, Suíte',
    selectOne: 'Selecione um...',
    setAsDefault: 'Definir como endereço de entrega padrão',
    titleRequired: 'Título obrigatório.',
    userAddressAddSuccess: 'O novo endereço foi adicionado com sucesso!',
    userAddressUpdateSuccess: 'Endereço atualizado com sucesso!',
    userAddressDeleteSuccess: 'Endereço excluído com sucesso!',
    invalidAddress: 'Endereço inválido',
  },
  addressBook: {
    addNewDeliveryAddress: 'Adicionar um novo endereço de entrega',
    editDeliveryAddress: 'Editar endereço de entrega',
    areYouSureToDeleteAddress: 'Tem certeza de que deseja excluir este endereço?',
    addNewAddress: 'Adicionar novo endereço',
    addAddress: 'Adicionar endereço',
    updateAddress: 'Endereço de atualização',
    backToAddressList: 'Voltar para a lista de endereços',
    defaultDeliveryAddress: 'Endereço de entrega padrão',
    additionalDeliveryAddress: 'Endereço de entrega adicional {{{number}}',
  },
  addressCard: {
    default: 'PREDETERMINADO',
    selected: 'Selecionado',
    setAsDefault: 'Definir como padrão',
    shipTo: 'Enviar a',
    billTo: 'Fatura',
    phoneNumber: 'P',
    mobileNumber: 'M',
  },
  addressSuggestion: {
    verifyYourAddress: 'Verifique seu endereço',
    ensureAccuracySuggestChange:
      'Para garantir a precisão da entrega, sugerimos a alteração selecionada abaixo.',
    chooseAddressToUse: 'Por favor, escolha o endereço que deseja usar:',
    suggestedAddress: 'Direção sugerida',
    enteredAddress: 'Endereço inserido',
    editAddress: 'Editar endereço',
    saveAddress: 'Salvar endereço',
  },
  addressMessages: {
    setAsDefaultSuccessfully:
      'O endereço {{ streetAddress }} foi definido corretamente como padrão',
  },
};
